export const TRANSLATIONS_HELP_US_IMPROVE_BANNER = {
  title: 'help_us_improve_banner.title',
  description: 'help_us_improve_banner.description',
  button: 'help_us_improve_banner.button',
  close: 'help_us_improve_banner.close'
};
